<template>
  <div>
    <h1>Room Creation</h1>
    <label>room name</label><el-input :disabled="true" v-model="name" />
    <label>room password</label><el-input :disabled="true" v-model="password" />
    <el-button @click="createRoom">create</el-button>
  </div>
</template>

<script>
export default {
  name: 'Contents',
  data () {
    return {
      name     : '',
      password : ''
    }
  },
  methods: {
    createRoom () {
      this.$router.push({name: 'room', params: {id: 'roomId'}})
    }
  },
  sockets: {
    createRoom (roomId) {
      console.log(roomId)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/roomCreation/index.vue